import { render, staticRenderFns } from "./NewEmployee.vue?vue&type=template&id=6cb6a340&"
import script from "./NewEmployee.vue?vue&type=script&lang=js&"
export * from "./NewEmployee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports